/** @format */

export enum FeatureConfigurationKeys {
  ADD_DRAWER = 'addDrawer',
  PRESELECT_PDP_BY_SIZE = 'preselectPDPBySize',
  SET_PRODUCT_CUSTOM_BADGE = 'setProductCustomBadge',
}

export enum PersonalizationDataKeys {
  MODIFY_DRAWERS = 'modifyDrawers',
  MODIFY_BUBBLE_FILTERS = 'modifyBubbleFilters',
  UPDATE_CLP_S1 = 'updateClpS1',
  MODIFY_PCS = 'modifyPCS',
  MODIFY_PDP_INFO_CALLOUT = 'modifyPDPInfoCallout',
  MODIFY_CAT_HAT_BANNER = 'modifyCatHatBanner',
  MODIFY_PLP_BANNER = 'modifyPLPBanner',
}

export const PERSONALIZATION_SERVICE = 'PersonalizationService';
